// extracted by mini-css-extract-plugin
export default {"driveButton":"drive-folder-button_driveButton__w1-N5","googleDriveIcon":"drive-folder-button_googleDriveIcon__qIzGG"};